import {
  Button,
  Menu,
  MoreIcon,
  PlusIcon,
} from "melco-ui";
import { Dropdown } from "antd";
// import { useTranslation } from "react-i18next";
import { useRolesContext } from "../../hooks/roles/useRolesContext";
import { AddHoopsSupplier } from "./AddHoopsSupplier";
import { AddThreadsSupplier } from "./AddThreadsSupplier";
import { AddMachinesSupplier } from "./AddMachinesSupplier";
import { HighlightedMenu } from "../../helper/commonHelper";


type AddSupplierActionDropdownProps = {

  setOpenSupplierDrawerAndSettingValuesFunction: (v: boolean, id: string) => void;

};

export const AddSupplierActionDropdown: React.FC<
  AddSupplierActionDropdownProps
> = ({ setOpenSupplierDrawerAndSettingValuesFunction }) => {
  //  const { t } = useTranslation();

  const { roles } = useRolesContext();

  //const shouldShowWarning = useShouldShowWarning();



  const options = (
    <HighlightedMenu>
      <Menu
      >
        {
          roles.SYSTEM_SUPPLIERS_CREATE &&
          <Menu.Item
            key="add-supplier-action"

            onClick={() => {

            }}

          >
            <AddHoopsSupplier
              setIsAddHoopsSupplierDrawerOpenAction={setOpenSupplierDrawerAndSettingValuesFunction}

            />
          </Menu.Item>
        }


        {
          roles.SYSTEM_SUPPLIERS_CREATE &&
          <Menu.Item
            onClick={() => { }}
          >

            <AddThreadsSupplier
              setIsAddThreadsSupplierDrawerOpenAction={setOpenSupplierDrawerAndSettingValuesFunction}
            />

          </Menu.Item>
        }


        {
          roles.SYSTEM_SUPPLIERS_CREATE &&
          <Menu.Item
            onClick={() => { }}
          >
            <AddMachinesSupplier
              setIsAddMachinesSupplierDrawerOpenAction={setOpenSupplierDrawerAndSettingValuesFunction}
            />
          </Menu.Item>
        }

      </Menu>

    </HighlightedMenu>);

  return (
    <Dropdown
      overlay={options}
      trigger={["click"]}
      placement="bottomRight"
      arrow




    >

      <Button
        key="add-supplier-actions"
        type="primary"
        data-cy-id="add-supplier-actions"
      >
        <PlusIcon /> Add Supplier <MoreIcon />
      </Button>
    </Dropdown>
  );
};
